import styled from 'styled-components';
import { baseVariables } from '../../styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
`;

export const MediaWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: var(--t-images-border-radius, 14px);
`;

export const CaptionWrapper = styled.div`
  margin-top: 0.5rem;
  width: 100%;
  text-align: center;

  ${baseVariables.mediaQuery.md} {
    margin-top: 0.5rem;
  }
`;

export default {
  Wrapper,
  MediaWrapper,
  CaptionWrapper,
};
